import { WalletIcon } from 'lucide-react'
import { useState } from 'react'

import { Button, TextButton } from 'slab'
import { type MoneyAmount } from 'types'

import PaymentsInfoModal from './PaymentsInfoModal'

type Props = {
  cardPaymentsEnabled: boolean
  balanceValue?: string
  variantPrice: MoneyAmount
  onClick: () => void
}

type PaymentScenario = 'card' | 'balance' | 'split' | 'insufficient_balance'

const determinePaymentScenario = (cardPaymentsEnabled: boolean, variantPrice: MoneyAmount, balanceValue?: string): PaymentScenario => {
  const hasBalance = !!balanceValue && parseFloat(balanceValue) > 0
  const balanceCoversPrice = balanceValue ? parseFloat(balanceValue) >= parseFloat(variantPrice.value) : false

  if (balanceCoversPrice) {
    return 'balance'
  }

  if (!cardPaymentsEnabled) {
    return 'insufficient_balance'
  }

  if (hasBalance) {
    return 'split'
  }

  return 'card'
}

const getSubtext = (paymentScenario: PaymentScenario): string | undefined => {
  switch (paymentScenario) {
    case 'split':
      return "Your Thatch balance doesn't fully cover the cost. You will need to use a personal card to pay for the remaining amount."
    case 'card':
      return "Your Thatch balance doesn't cover the cost. You will need to use a personal card to pay for the entire amount."
    case 'insufficient_balance':
      return "You don't have enough balance to purchase this item."
  }
}

export default function CheckoutButton ({ cardPaymentsEnabled, balanceValue, variantPrice, onClick }: Props) {
  const paymentScenario = determinePaymentScenario(cardPaymentsEnabled, variantPrice, balanceValue)
  const subtext = getSubtext(paymentScenario)
  const [showLearnMore, setShowLearnMore] = useState(false)

  return (
    <div className='flex flex-col gap-3'>
      <Button
        onClick={onClick}
        size='large'
        variant='primary'
        width='full'
        disabled={paymentScenario === 'insufficient_balance'}
      >
        Proceed to checkout
      </Button>
      {subtext &&
        (
          <div className='flex gap-2'>
            <div className='text-gray-400'>
              <WalletIcon size={20} />
            </div>
            <div className='body-sm text-gray-500'>{subtext} {paymentScenario !== 'insufficient_balance' && <TextButton onClick={() => setShowLearnMore(true)}>Learn more</TextButton>}</div>
          </div>
        )}
      <PaymentsInfoModal open={showLearnMore} onOpenChange={setShowLearnMore} />
    </div>
  )
}
